(function($) {
  Drupal.behaviors.updateProductLink = {
    attach: function(context) {
      var sku_id = $('.product-full', context).data('sku-base-id');
      $('.product-link-suffix', context).each(function() {
        var href = $(this).attr('href');
        $(this).attr('href', href + sku_id);
      });
    }
  };
})(jQuery);
